import SpotlightMetadata from './SpotlightMetadata'

export default SpotlightMetadata
// eslint-disable-next-line import/export
export * from './SpotlightMetadata'
